module.exports = __webpack_public_path__ + "static/media/thumbs.0f03e98b.svg";